var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSlideDown = function SvgSlideDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 128,
    viewBox: "0 0 128 128",
    width: 128,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.032 13.869C36.39 13.869 13.903 36.358 13.903 64c.002 27.643 22.49 50.131 50.131 50.131 27.64 0 50.126-22.488 50.126-50.131 0-27.642-22.487-50.131-50.128-50.131zm.002 96.262C38.6 110.131 17.905 89.438 17.903 64c0-25.437 20.693-46.131 46.129-46.131 25.435 0 46.128 20.694 46.128 46.131 0 25.438-20.692 46.131-46.126 46.131zm14.505-41.213L66.034 79.694V43.942a2 2 0 0 0-4 0v35.752L49.527 68.918a2 2 0 1 0-2.611 3.031l17.118 14.748L81.15 71.949a2 2 0 1 0-2.611-3.031z"
  })));
};
export default SvgSlideDown;